import React, {  useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import menu from "../Data/Menu/menu.json";
import { Dropdown } from "react-bootstrap";
import Profile from "../../assets/images/profile_av.svg";
import { Modal } from "react-bootstrap";
import white_logo from "./harmoni.png"

function Sidebar(props) {
  const navigate = useNavigate();

  const [menuData, setMenuData] = useState([...menu.menu]);
  const [isLogoutModal, setIsLogoutModal] = useState(false);

  const openChildren = (id) => {
    const otherTabs = document.getElementsByClassName("has-children");
    if (otherTabs) {
      for (let i = 0; i < otherTabs.length; i++) {
        if (otherTabs[i].id !== id) {
          otherTabs[i].className = otherTabs[i].className.replace(" show", "");
          if (otherTabs[i].parentElement.children.length > 1) {
            otherTabs[i].parentElement.children[0].setAttribute(
              "aria-expanded",
              "false"
            );
          }
        }
      }
    }
    const menutab = document.getElementById(id);
    if (menutab) {
      if (menutab.classList.contains("show")) {
        menutab.classList.remove("show");
        if (menutab.parentElement.children.length > 1) {
          menutab.parentElement.children[0].setAttribute(
            "aria-expanded",
            "false"
          );
        }
      } else {
        menutab.classList.add("show");
        if (menutab.parentElement.children.length > 1) {
          menutab.parentElement.children[0].setAttribute(
            "aria-expanded",
            "true"
          );
        }
      }
    }
  };
  const openChildren1 = (id) => {
    const otherTabs = document.getElementsByClassName("has-children");
    if (otherTabs) {
      for (let i = 0; i < otherTabs.length; i++) {
        otherTabs[i].className = otherTabs[i].className.replace(" show", "");
      }
    }
    const menutab = document.getElementById(id);
    if (menutab) {
      menutab.classList.add("show");
      if (menutab.parentElement.children.length > 1) {
        menutab.parentElement.children[0].setAttribute("aria-expanded", "true");
      }
    }
  };

  const GotoChangeMenu = (val) => {
    navigate("dashboard");
    setMenuData([...menu.menu]);
  };
  const { activekey } = props;

  let user = JSON.parse(localStorage.getItem("userData"))  || {};

  return (
    <>
      <div
        id="mainsidemenu"
        className={`sidebar px-3 py-3 py-md-3 me-0 `}
        style={{ overflow: "visible" }}
      >
        <div className="d-flex flex-column h-100">
          <Dropdown className="dropdown user-profilem d-flex align-items-center zindex-popover gap-1">
            <Dropdown.Toggle
            onClick={()=>navigate("/user-list")}
              as="a"
              className="nav-link dropdown-toggle pulse p-0 d-flex align-items-center"
              // href="#!"
              role="button"
            >
              <img
                className="avatar lg rounded-circle img-thumbnail"
                src={
                  user && user?.is_superuser === true
                    ? Profile
                    : (user && user?.image) ?? Profile
                }
                alt="profile"
              />
              <div className="flex-fill ms-2">
                <p className="mb-0">
                  <span className="font-weight-bold text-white">
                    {" "}
                    {user?.userName
                      ? user?.userName?.toUpperCase()
                      : "Admin"}
                  </span>
                </p>
                <small
                  className="text-white"
                  style={{
                    wordBreak: "break-all",
                    display: "block",
                    whiteSpace: "normal",
                  }}
                >
                  {" "}
                  {user && user?.email}
                </small>
              </div>
            </Dropdown.Toggle>
          </Dropdown>

          <ul className="menu-list flex-grow-1 mt-3">
            {menuData.map((d, i) => {
              if (d.isToggled) {
                return (
                  <li key={"shsdg" + i}>
                    <a
                      className={`m-link `}
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        GotoChangeMenu(d.name);
                      }}
                    >
                      <i className={d.iconClass}></i>
                      <span>{d.name}</span>
                    </a>
                  </li>
                );
              }
              if (d.children.length === 0) {
                return (
                  <li
                    key={"dsfshsdg" + i}
                    className=" collapsed"
                    onClick={() => {
                      const sidebar = document.getElementById("mainsidemenu");
                      if (sidebar) {
                        if (sidebar.classList.contains("open")) {
                          sidebar.classList.remove("open");
                        } else {
                          sidebar.classList.add("open");
                        }
                      }
                    }}
                  >
                    <Link
                      to={"/" + d.routerLink[0]}
                      className={`m-link ${d.routerLink[0] === activekey ? "active" : ""
                        }`}
                    >
                      <i className={d.iconClass}></i>
                      <span>{d.name}</span>
                      <span className="ms-auto text-end fs-5"></span>
                    </Link>
                  </li>
                );
              }

              return (
                <li key={"shsdg" + i} className=" collapsed">
                  <a
                    className={`m-link ${d.children.filter(
                      (d) => "/" + d.routerLink[0] === activekey
                    ).length > 0
                        ? "active"
                        : ""
                      }`}
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault();
                      openChildren("menu-Pages" + i);
                    }}
                  >
                    <i className={d.iconClass}></i>
                    <span>{d.name}</span>
                    <span className="arrow icofont-dotted-down ms-auto text-end fs-5"></span>
                  </a>
                  {d.children.length > 0 ? (
                    <ul
                      className="sub-menu collapse has-children"
                      id={"menu-Pages" + i}
                    >
                      {d.children.map((data, ind) => {
                        if (d.children.length > 0) {
                          if (activekey === "/" + data.routerLink[0]) {
                            setTimeout(() => {
                              openChildren1("menu-Pages" + i);
                            }, 500);
                          }
                        }

                        return (
                          <li
                            key={"jfdgj" + ind}
                            onClick={() => {
                              const sidebar =
                                document.getElementById("mainsidemenu");
                              if (sidebar) {
                                if (sidebar.classList.contains("open")) {
                                  sidebar.classList.remove("open");
                                } else {
                                  sidebar.classList.add("open");
                                }
                              }
                            }}
                          >
                            <Link
                              className={
                                activekey === "/" + data.routerLink[0]
                                  ? "ms-link active"
                                  : "ms-link"
                              }
                              to={
                               "/" +
                                data.routerLink[0]
                              }
                            >
                              {" "}
                              <span>{data.name}</span>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                </li>
              );
            })}
          </ul>
          <div className="sidebarBottom">
          <img src={white_logo} alt="white_logo" />

            <div
              className="list-group m-2 "
              onClick={() => {
                setIsLogoutModal(true);
              }}
            >
              <span className="list-group-item list-group-item-action border-0 cursor-pointer">
                <i className="icofont-logout fs-5 me-3"></i>Logout
              </span>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={isLogoutModal}
        onHide={() => {
          setIsLogoutModal(false);
        }}
        style={{ display: "block" }}
      >
        <Modal.Header
          className="modal-header"
          style={{
            position: "absolute",
            top: "14px",
            right: "14px",
            zIndex: "99",
            border: "none",
            width: "max-content",
          }}
        ></Modal.Header>
        <Modal.Body className="modal-body">
          <div className="deadline-form">
            <form>
              <h4
                style={{
                  textAlign: "center",
                  fontSize: "22px",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                Are you sure you want to logout?
              </h4>
              <div className="LogouModal">
                <button
                  onClick={() => {
                    setIsLogoutModal(false);
                  }}
                  type="button"
                  className="btn btn-secondary"
                >
                  Cancel
                </button>

                <button
                  onClick={() => {
                    localStorage.removeItem("token");
                    localStorage.removeItem("userData");
                    setTimeout(() => {
                      navigate("/sign-in/", { replace: true });
                    }, 1000);
                  }}
                  type="button"
                  className="btn btn-primary"
                >
                  Logout
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Sidebar;
